import auth from 'lib/utils/auth';
import { isServer } from 'lib/common/constants';

export default () => (next) => (action) => {
  if (!isServer) {
    switch (action.type) {
      case 'LOGOUT_REQUEST':
        auth.clearToken();
        auth.clear();
        break;
      case 'LOGOUT_SUCCESS':
      case 'LOGOUT_FAILURE':
        /* eslint-disable camelcase */
        /* eslint-disable no-undef */
        if (window.embedded_svc) {
          embedded_svc?.liveAgentAPI.endChat();
          embedded_svc?.liveAgentAPI.clearSession();
        }
        window.location.reload();
        break;
      case 'LOGIN_SUCCESS':
      case 'UPDATE_ACCESS_TOKEN':
        auth.setToken(action.payload.access_token);
        break;
      default:
        break;
    }
  }

  return next(action);
};
